<template>
	<div class="warning-item" :class="colorClass">
		<div class="warning-item-icon" :class="colorClass">
			<sym-icon name="warning-16"/>
		</div>
		<div class="warning-item-message">
			<span v-html="warning.content"></span>
			<span style="display:flex;gap:4px">
				<it-link v-if="warning.id" :to="'editWarning.do?id='+warning.id" class="fi-edit-icon"><sym-icon name="edit"></sym-icon></it-link>
				<fi-date v-if="warning.modified || warning.entered" :value="warning.modified || warning.entered"></fi-date>
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import {SrcType} from "@t/meta/SourceType.ts";
import ObjectLink from "@fd/helpers/ObjectLink.vue";
import FiDate from "@/processes/FiDate.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ItLink from "@/router/ItLink.vue";
import {Warning} from "@t/note/Warning.ts";
import {DEFAULT_EVENT_COLOR} from "@t/fd/editor/EventColor.ts";

const props = defineProps<{
	warning: Warning
}>();

const colorClass = computed<string>(()=> { return "color-"+(props.warning.color?props.warning.color:DEFAULT_EVENT_COLOR); });

</script>

<style>
.fi-edit-icon {
	cursor: pointer;
	opacity: 0.5;
	&:hover {
		opacity: 1;
	}
}
</style>